// @flow

export function isInvalidProAccount(plan: ?string): boolean {
  if (!plan) {
    return false;
  }
  return plan === "Delinquent" || plan === "Overdue" || plan === "Disabled";
}
